<div [formGroup]="formGroup.form">
  <z-popup-lov
    [list]="facilityList$ | async"
    [fieldName]="fieldName"
    [enableDropdown]="true"
    [label]="label"
    [placeholder]="placeholder"
    [buttonAction]="openDialog"
    [columnsConfig]="{ column1: { width: 70 } }"
    [hint]="hint"
    [readonly]="readonly"
    [disabled]="disabled"
    [uppercase]="uppercase"
    [clearButton]="clearButton"
    [manualInput]="manualInput"
    [enableDropdown]="enableDropdown"
    [showDropdownFilter]="showDropdownFilter"
    [doubleClickToOpenPopup]="doubleClickToOpenPopup"
    [allowMultipleValues]="allowMultipleValues"
    [showToggleAll]="showToggleAll"
    [selectionLimit]="selectionLimit"
    (change)="onChangeHandler($event)"
    (clear)="onClearHandler($event)"
  >
  </z-popup-lov>
</div>
